// add csv to same directory as this file
// import data from './example.csv';
var Isotope = require('isotope-layout');;

const docReady = function(func) {
  // https://stackoverflow.com/a/9899701
    // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(func, 1);
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
};

const debounce = function(func, wait, immediate) {
  // https://davidwalsh.name/javascript-debounce-function
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

docReady(() => {

  // run nav bar
  const grids = document.getElementsByClassName('grid');
  for (let grid of grids) {
    const iso = new Isotope( grid, {
      // options
      itemSelector: '.bill',
      layoutMode: 'masonry',
      transitionDuration: 0,
      animationOptions: {
        duration: 0,
      }
    });
  }

  // init pym
  const pymChild = new pym.Child();

  // send height
  pymChild.sendHeight();

  // when dropdown is selected
  const stateDropdownEl = document.getElementById('state__dropdown');
  stateDropdownEl.addEventListener('change', function(e) {
    const state = stateDropdownEl.value;
    document.getElementById(state).scrollIntoView({
      behavior: 'smooth',
    });
  });


  // when click on SAST link
  const sastLinks = document.getElementsByClassName('sast_link');
  for (let i=0; i < sastLinks.length; i++) {
    sastLinks[i].addEventListener('click', e => {
      e.preventDefault();
      const bill = e.target.dataset.link;
      const smooth = {
        behavior: 'smooth',
        block: 'center'
      };


      document.getElementById(bill).scrollIntoView(smooth);
    });
  }

  const resizeFn = debounce(() => {
    pymChild.sendHeight();
  }, 400);

  // add pym resize
  window.addEventListener('resize', resizeFn);
});